var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.632812,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.632812,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "currentStroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 19.5329L13.0998 24.4329C12.9165 24.6162 12.6831 24.7079 12.3998 24.7079C12.1165 24.7079 11.8831 24.6162 11.6998 24.4329C11.5165 24.2495 11.4248 24.0162 11.4248 23.7329C11.4248 23.4495 11.5165 23.2162 11.6998 23.0329L16.5998 18.1329L11.6998 13.2329C11.5165 13.0495 11.4248 12.8162 11.4248 12.5329C11.4248 12.2495 11.5165 12.0162 11.6998 11.8329C11.8831 11.6495 12.1165 11.5579 12.3998 11.5579C12.6831 11.5579 12.9165 11.6495 13.0998 11.8329L17.9998 16.7329L22.8998 11.8329C23.0831 11.6495 23.3165 11.5579 23.5998 11.5579C23.8831 11.5579 24.1165 11.6495 24.2998 11.8329C24.4831 12.0162 24.5748 12.2495 24.5748 12.5329C24.5748 12.8162 24.4831 13.0495 24.2998 13.2329L19.3998 18.1329L24.2998 23.0329C24.4831 23.2162 24.5748 23.4495 24.5748 23.7329C24.5748 24.0162 24.4831 24.2495 24.2998 24.4329C24.1165 24.6162 23.8831 24.7079 23.5998 24.7079C23.3165 24.7079 23.0831 24.6162 22.8998 24.4329L17.9998 19.5329Z",
    fill: "#969CA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.e9ea537be3ecc3b108f4e288d7ffdaad.svg";
export { ForwardRef as ReactComponent };